import { useEffect } from 'react';
import { mapValues } from 'lodash';
import { PROFILE_FIELDS_TYPES } from '../../../constants/formFields';
import {
  makeRequiredFieldsValidator,
  useFormState,
} from '../../../hocs/useFormWithValidation';

export const initialState = {
  [PROFILE_FIELDS_TYPES.START_TIME]: null,
  [PROFILE_FIELDS_TYPES.DATE]: null,
  [PROFILE_FIELDS_TYPES.LOCATION]: null,
  [PROFILE_FIELDS_TYPES.SERVICE]: null,
  [PROFILE_FIELDS_TYPES.REASON_TYPE_ID]: null,
  [PROFILE_FIELDS_TYPES.REASON_COMMENT]: null,
  [PROFILE_FIELDS_TYPES.PROVIDER]: null,
  [PROFILE_FIELDS_TYPES.COPAY]: null,
};

export const validateRequiredFields = makeRequiredFieldsValidator([
  PROFILE_FIELDS_TYPES.START_TIME,
  PROFILE_FIELDS_TYPES.DATE,
  PROFILE_FIELDS_TYPES.LOCATION,
  PROFILE_FIELDS_TYPES.SERVICE,
  PROFILE_FIELDS_TYPES.REASON_TYPE_ID,
  PROFILE_FIELDS_TYPES.PROVIDER,
]);

export function useVisitInfoForm() {
  const { formState, handleFormChange, clearForm } = useFormState(initialState);
  const location = formState[PROFILE_FIELDS_TYPES.LOCATION];
  const service = formState[PROFILE_FIELDS_TYPES.SERVICE];

  function populateData(fieldKey) {
    if (formState) {
      const populate = mapValues(formState, (value, key) => {
        if (key === fieldKey) return null;

        return formState[key] || null;
      });
      handleFormChange(populate);
    }
  }

  useEffect(() => {
    populateData(PROFILE_FIELDS_TYPES.SERVICE);
  }, [location]);

  useEffect(() => {
    populateData(PROFILE_FIELDS_TYPES.REASON_TYPE_ID);
  }, [service]);

  const isValid = validateRequiredFields(formState);

  return {
    formState,
    handleFormChange,
    clearForm,
    isValid,
  };
}



// WEBPACK FOOTER //
// ./src/components/VirtualVisit/utils/useVisitInfoFormState.js